import { addDoc, collection } from "firebase/firestore";
import { db } from "cloud/firebase";

export async function pushDb(data) {
  const docRef = await addDoc(collection(db, "survey"), data);
}
